/**
 * Video-game press + haptic feedback for clickable controls (Dawn).
 * Uses Vibration API on touch where supported (many Android devices; iOS often no-ops).
 */
(function () {
  const SELECTOR = [
    'a.button',
    'button:not(.slider-button):not(.flickity-button):not(.pswp__button):not(.button-show-more):not(.button-show-less):not(.quantity__button):not(.pickup-availability-button):not(.product__media-toggle):not(.thumbnail):not(.deferred-media__poster):not(.ri-home-carousel__arrow):not(.ri-generator__slot):not(.ri-sort__option)',
    '.ri-home__franchise',
    'input[type="submit"]',
    'input[type="button"]',
    '.button',
    '.header__icon',
    '.header__heading-link',
    '.pagination__item',
    '.list-menu__item--link',
    '.disclosure__button',
    '.product-form__submit',
    '.cart__checkout-button',
    '.ri-sticky-atc__button',
    '.ri-go',
    '.card-wrapper .card__media',
    '.facets-vertical-sort .facet-filters__field .select',
    '.shopify-payment-button__button',
    '[role="button"]',
  ].join(',');

  const SKIP = '.rte, .product__description, .article-template, .announcement-bar, .footer-block__details-content, .inline-richtext, .tq-app--phone, .ri-tq-tally';

  function fromAccountSheet(event) {
    if (typeof event.composedPath !== 'function') return false;
    return event.composedPath().some(function (node) {
      if (!(node instanceof Element)) return false;
      if (node.tagName === 'SHOP-LOGIN') return true;
      if (node.tagName !== 'DIALOG') return false;
      var root = node.getRootNode();
      return root instanceof ShadowRoot && root.host && root.host.tagName === 'SHOPIFY-ACCOUNT';
    });
  }

  function isGameTarget(el, event) {
    if (!el || el.closest?.(SKIP)) return null;
    if (el.closest?.('.ri-header-search__submit, .ri-header-search__close, .ri-header-search__scope-x, summary.header__menu-item, summary.ri-sort__summary, .ri-sort__option')) return null;
    /* A product tile is one link: pressing its name or price presses the cover. Its Add to cart is its own. */
    var tile = el.closest?.('.card-wrapper');
    if (tile && el.closest('a') && !el.closest('button, .ri-card-atc, .ri-choose-options')) {
      var media = tile.querySelector('.card__media');
      /* Only a press on the cover itself presses it (owner, 2026-10-23), with a mouse or a finger: a click on the
         name or price, or a finger landing there to scroll, leaves the cover still. The name's link can cover the
         whole tile, so this goes by where the pointer is, not which element it hit. */
      if (media && event && typeof event.clientX === 'number') {
        var r = media.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) {
          return null;
        }
      }
      return media || el.closest(SELECTOR);
    }
    return el.closest?.(SELECTOR);
  }

  function haptic(pointerType) {
    if (pointerType !== 'touch' && pointerType !== 'pen') return;
    if (typeof navigator.vibrate === 'function') {
      try {
        navigator.vibrate(14);
      } catch (_) {}
    }
  }

  var atcDown = null;
  var ATC =
    '.ri-card-atc__add, .ri-choose-options__variant-btn, .product-form__submit, .ri-sticky-atc__button, [name="add"]';

  function press(el, on) {
    if (!el) return;
    el.classList.toggle('is-pressed', on);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      atcDown = null;
      if (fromAccountSheet(event)) return;
      const target = isGameTarget(event.target, event);
      if (!target) return;
      press(target, true);
      if (!target.closest(ATC)) return;
      atcDown = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        scrollY: window.scrollY || 0,
        target: target,
        type: event.pointerType,
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!atcDown || event.pointerId !== atcDown.id) return;
      var dx = Math.abs(event.clientX - atcDown.x);
      var dy = Math.abs(event.clientY - atcDown.y);
      var scrolled = Math.abs((window.scrollY || 0) - atcDown.scrollY) > 4;
      var releasedOn = event.target && atcDown.target.contains(event.target);
      if (!scrolled && dx < 12 && dy < 12 && releasedOn) haptic(atcDown.type);
      atcDown = null;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointercancel',
    function (event) {
      if (atcDown && event.pointerId === atcDown.id) atcDown = null;
    },
    { passive: true }
  );

  function clearPress(event) {
    const target = isGameTarget(event.target);
    if (target) press(target, false);
    document.querySelectorAll('.is-pressed').forEach(function (el) {
      el.classList.remove('is-pressed');
    });
  }

  document.addEventListener('pointerup', clearPress, { passive: true });
  document.addEventListener('pointercancel', clearPress, { passive: true });
  document.addEventListener('pointerleave', clearPress, { passive: true });

  /* Focus rings show only while someone is moving with the keyboard. A tap or click hides them again. */
  var root = document.documentElement;
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Tab' || event.key === 'F6') root.classList.add('ri-kbd');
    },
    true
  );
  document.addEventListener(
    'pointerdown',
    function () {
      root.classList.remove('ri-kbd');
    },
    { capture: true, passive: true }
  );
})();
